import React, { useState } from 'react';
import { PanelLeft, PanelLeftClose } from 'lucide-react';
import Header from '../Header/Header';
import CategorySidebar from '../CategorySidebar/CategorySidebar';
import './Layout.css';

function Layout({ children }) {
  const [sideNavOpen, setSideNavOpen] = useState(false);
  const [categorySidebarOpen, setCategorySidebarOpen] = useState(false);
  
  return (
    <div className={`homepage ${sideNavOpen ? 'side-nav-open' : ''}`}>
      <Header sideNavOpen={sideNavOpen} setSideNavOpen={setSideNavOpen} />
      <div className="main-content">
        <button
          type="button"
          className="mobile-category-toggle"
          onClick={() => setCategorySidebarOpen(prev => !prev)}
          aria-label={categorySidebarOpen ? 'Hide categories' : 'Show categories'}
        >
          {categorySidebarOpen ? <PanelLeftClose size={18} /> : <PanelLeft size={18} />}
          {categorySidebarOpen ? 'Hide Categories' : 'Browse Categories'}
        </button>
        <div className="content-wrapper">
          {children}
        </div>
        <CategorySidebar
          visible={categorySidebarOpen}
          onClose={() => setCategorySidebarOpen(false)}
        />
      </div>
    </div>
  );
}

export default Layout;
